import * as userActions from '../user/actions';
import * as lawsFiltersActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';
import { REHYDRATE } from 'redux-persist';
import { computeDatesFilter, searchParams, sortedBy, isSavedFilters } from '~utils/filters';
import { priorityFilters } from '~redux_related/activeFeed/reducer';

const initialState = {
    isFilters: false,
    isEqualsSaved: true, // флаг сравнения с сохраненными фильтрами в редьюсере user
    search: {
        value: '',
        dropdownValue: searchParams.titleAndText,
    },
    categories: null,
    themes: null,
    dates: {
        startDate: null,
        endDate: null,
        range: '',
    },
    documentTypes: null,
    sources: null,
    priority: priorityFilters.all,
    // importance: true,
    sortedBy: sortedBy.publicationDate,
    plan: false,
};

// Проверяет наличие фильтров на основе стэйта, возвращает bool
const computeIsFilters = (state, ecosystemFunctions) => {
    const isPlanFilterAvail = Boolean(ecosystemFunctions instanceof Object && ecosystemFunctions.rule_making_plan);
    const planValue = isPlanFilterAvail ? state.plan : false;
    return Boolean(
        state.search.value ||
            state.categories ||
            state.themes ||
            state.dates.startDate ||
            state.dates.endDate ||
            state.documentTypes ||
            // state.categories ||
            state.groups ||
            state.importance ||
            planValue
    );
};

// Удаляет элементы списка, возвращает новый список без удаленного элемента
// когда список становится пустым, возвращает null. Чистая функция.
// action берет из замыкания
const deleteItemFromList = (list, conditionCallback) => {
    // conditionCallback - колбек для сравнения элементов списка
    try {
        const itemToDeleteIndex = Array.isArray(list) && list.findIndex(conditionCallback);

        let updatedList = [];
        if (itemToDeleteIndex !== -1) {
            // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
            updatedList = [...list];
            updatedList.splice(itemToDeleteIndex, 1);
        }
        return updatedList && updatedList.length ? updatedList : null;
    } catch (err) {
        console.error(err.errorMessage);
    }
};

// переменная для промежуточного добавления обновленного state
// для корректного пересчета свойства isFilters
let updatedState = initialState;
let ecosystemFunctions = null;

export const lawsMyActionsFiltersReducer = (state = initialState, action) => {
    ecosystemFunctions = action.ecosystemFunctions;
    switch (action.type) {
        // Categories
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_CATEGORIES_FILTER:
            localStorage.setItem('my_actions_categories', JSON.stringify(action.categories));
            return {
                ...state,
                categories: action.categories,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_CATEGORY_FROM_FILTER:
            const listUpdatedCategories = deleteItemFromList(state.categories, (item) => item.id === action.id);
            updatedState = {
                ...state,
                categories: listUpdatedCategories,
            };
            localStorage.setItem('my_actions_categories', JSON.stringify(listUpdatedCategories));
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters:
                    listUpdatedCategories || computeIsFilters(updatedState, ecosystemFunctions)
                        ? computeIsFilters(updatedState, ecosystemFunctions)
                        : false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_CATEGORIES_FILTER:
            updatedState = {
                ...state,
                categories: null,
            };
            localStorage.removeItem('my_actions_categories');
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Themes
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_THEMES_FILTER:
            localStorage.setItem('my_actions_themes', JSON.stringify(action.themes));
            return {
                ...state,
                themes: action.themes,
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_THEME_FROM_FILTER:
            const listUpdatedThemes = deleteItemFromList(state.themes, (item) => item.id === action.id);
            updatedState = {
                ...state,
                themes: listUpdatedThemes,
            };
            localStorage.setItem('my_actions_themes', JSON.stringify(listUpdatedThemes));
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters:
                    listUpdatedThemes || computeIsFilters(updatedState, ecosystemFunctions)
                        ? computeIsFilters(updatedState, ecosystemFunctions)
                        : false, // god damn, надо с этим что-то делать
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_THEMES_FILTER:
            updatedState = {
                ...state,
                themes: null,
            };
            localStorage.removeItem('my_actions_themes');
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Dates
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_DATES_RANGE_FILTER:
            localStorage.setItem(
                'my_actions_dates',
                JSON.stringify({
                    startDate: action.startDate,
                    endDate: action.endDate,
                    range: action.range,
                })
            );

            return {
                ...state,
                dates: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                    range: action.range,
                },
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DATES_RANGE_FILTER:
            updatedState = {
                ...state,
                dates: {
                    startDate: null,
                    endDate: null,
                    range: '',
                },
            };
            localStorage.removeItem('my_actions_dates');
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Search
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_SEARCH_FILTER:
            localStorage.setItem('my_actions_search', JSON.stringify(action.text));
            return {
                ...state,
                search: {
                    ...state.search,
                    value: action.text,
                },
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_IS_TITLE_ONLY:
            return {
                ...state,
                search: {
                    ...state.search,
                    dropdownValue: action.value,
                },
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SEARCH_FILTER:
            localStorage.removeItem('my_actions_search');
            updatedState = {
                ...state,
                search: {
                    value: '',
                    dropdownValue: searchParams.titleAndText,
                },
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SEARCH_ITEM:
            updatedState = {
                ...state,
                search: {
                    ...state.search,
                    value: '',
                },
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Document Types
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_DOCUMENT_TYPE_FILTER:
            localStorage.setItem('my_actions_document_types', JSON.stringify(action.documentTypes));
            return {
                ...state,
                documentTypes: action.documentTypes,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DOCUMENT_TYPE_FROM_FILTER:
            const listUpdatedDocumentTypes = deleteItemFromList(state.documentTypes, (item) => item.id === action.id);
            updatedState = {
                ...state,
                documentTypes: listUpdatedDocumentTypes,
            };
            localStorage.setItem('my_actions_document_types', JSON.stringify(listUpdatedDocumentTypes));
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DOCUMENT_TYPE_FILTER:
            updatedState = {
                ...state,
                documentTypes: null,
            };
            localStorage.removeItem('my_actions_document_types');
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Sources
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_SOURCES_FILTER:
            localStorage.setItem('my_actions_sources', JSON.stringify(action.listSources));
            return {
                ...state,
                sources: action.listSources,
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SOURCE_FROM_FILTER:
            const listUpdatedSources = deleteItemFromList(state.categories, (item) => item.id === action.id);
            updatedState = {
                ...state,
                sources: listUpdatedSources,
            };
            localStorage.setItem('my_actions_sources', JSON.stringify(listUpdatedSources));
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SOURCES_FILTER:
            updatedState = {
                ...state,
                sources: null,
            };
            localStorage.removeItem('my_actions_sources');
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Groups
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_GROUPS_FILTER:
            localStorage.setItem('my_actions_groups', JSON.stringify(action.listGroups));
            return {
                ...state,
                groups: action.listGroups,
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_GROUP_FROM_FILTER:
            const listUpdatedGroups = deleteItemFromList(state.groups, (item) => item.id === action.id);
            updatedState = {
                ...state,
                groups: listUpdatedGroups,
            };

            localStorage.setItem('my_actions_groups', JSON.stringify(listUpdatedGroups));

            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_GROUPS_FILTER:
            updatedState = {
                ...state,
                groups: null,
            };

            localStorage.setItem('my_actions_groups', JSON.stringify([]));

            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Importance
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_IMPORTANCE_FILTER:
            updatedState = {
                ...state,
                importance: action.value,
            };

            if (action.value) {
                localStorage.setItem('my_actions_importance', JSON.stringify(action.value));
            } else {
                localStorage.removeItem('my_actions_importance');
            }

            return {
                ...state,
                importance: action.value,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // SortedBy
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_SORT_FILTER:
            return {
                ...state,
                sortedBy: action.sortBy,
                isEqualsSaved: false,
            };

        // Plan
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_PLAN_FILTER:
            updatedState = {
                ...state,
                plan: action.value,
            };

            if (action.value) {
                localStorage.setItem('my_actions_plan', JSON.stringify(action.value));
            } else {
                localStorage.removeItem('my_actions_plan');
            }

            return {
                ...state,
                plan: action.value,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
            };

        // Covid filters
        case lawsFiltersActions.APPLY_COVID_FILTERS:
            return {
                ...initialState,
                categories: action.filters.categories,
                themes: action.filters.themes,
                isEqualsSaved: false,
                isFilters: true,
            };

        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_ALL_FILTERS:
            return {
                ...initialState,
                sortedBy: state.sortedBy,
                isEqualsSaved: false,
            };

        case lawsFiltersActions.LAWS_MY_ACTIONS_SET_FILTERS:
            return Boolean(action.filters)
                ? {
                      ...action.filters,
                      isEqualsSaved: true,
                  }
                : initialState;

        case lawsFiltersActions.LAWS_MY_ACTIONS_SET_INITIAL_FILTERS:
            const newDatesFilter = computeDatesFilter(action.filters.dates);
            return Boolean(action.filters)
                ? {
                      ...action.filters,
                      dates: newDatesFilter,
                      isEqualsSaved: true,
                  }
                : initialState;

        case userActions.SAVE_LAWS_MY_ACTIONS_USER_FILTERS:
            return {
                ...state,
                isEqualsSaved: Boolean(action.filters),
            };

        case userActions.DELETE_LAWS_MY_ACTIONS_USER_FILTERS:
            return {
                ...state,
                isEqualsSaved: false,
            };

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 19+++');
            const lawsMyActionsSavedFilters = action.user.my_actions_feed_saved_filters;
            ecosystemFunctions = action.user.ecosystem ? action.user.ecosystem.functions : null;
            if (!isSavedFilters(lawsMyActionsSavedFilters)) return initialState;
            const { startDate, endDate, range } = computeDatesFilter(lawsMyActionsSavedFilters.dates);

            updatedState = {
                ...initialState,
                ...lawsMyActionsSavedFilters,
                search: {
                    dropdownValue: lawsMyActionsSavedFilters.search.dropdownValue,
                    value: lawsMyActionsSavedFilters.search.value,
                },
                dates: {
                    startDate,
                    endDate,
                    range,
                },
            };

            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
                isEqualsSaved: true,
            };

        case userActions.LOGOUT:
            return initialState;

        // При обновлении страницы сэттим фильтры, берем их из сохраненных
        // Ни разу не лагало, думаю, что экшен безопасный
        case REHYDRATE:
            console.log('+++REHYDRATE BIG 4+++');
            ecosystemFunctions =
                action.payload &&
                action.payload.user &&
                action.payload.user.ecosystem &&
                action.payload.user.ecosystem.functions;
            let savedUserFilters =
                (action.payload && action.payload.user && action.payload.user.lawsMyActionsSavedFilters) || {};

            let { startDate: start, endDate: end, range: rangeStr } = computeDatesFilter(savedUserFilters.dates);

            if (localStorage.getItem('my_actions_categories')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    categories: JSON.parse(localStorage.getItem('my_actions_categories')),
                };
            }
            if (localStorage.getItem('my_actions_themes')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    themes: JSON.parse(localStorage.getItem('my_actions_themes')),
                };
            }
            if (localStorage.getItem('my_actions_dates')) {
                const dates = JSON.parse(localStorage.getItem('my_actions_dates'));
                start = dates.startDate;
                end = dates.endDate;
                rangeStr = dates.range;
            }
            if (localStorage.getItem('my_actions_document_types')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    documentTypes: JSON.parse(localStorage.getItem('my_actions_document_types')),
                };
            }
            if (localStorage.getItem('my_actions_sources')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    sources: JSON.parse(localStorage.getItem('my_actions_sources')),
                };
            }
            if (localStorage.getItem('my_actions_importance')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    importance: JSON.parse(localStorage.getItem('my_actions_importance')),
                };
            } else {
                savedUserFilters = {
                    ...savedUserFilters,
                    importance: undefined,
                };
            }
            if (localStorage.getItem('my_actions_plan')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    plan: JSON.parse(localStorage.getItem('my_actions_plan')),
                };
            } else {
                savedUserFilters = {
                    ...savedUserFilters,
                    plan: undefined,
                };
            }
            if (localStorage.getItem('my_actions_search')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    search: JSON.parse(localStorage.getItem('my_actions_search')),
                };
            }
            if (localStorage.getItem('my_actions_groups')) {
                savedUserFilters = {
                    ...savedUserFilters,
                    groups: JSON.parse(localStorage.getItem('my_actions_groups')),
                };
            }

            if (!isSavedFilters(savedUserFilters)) return initialState;

            updatedState = {
                ...initialState,
                ...savedUserFilters,
                search: savedUserFilters.search
                    ? {
                          dropdownValue: savedUserFilters.search.dropdownValue,
                          value: savedUserFilters.search.value,
                      }
                    : {},
                dates: {
                    startDate: start,
                    endDate: end,
                    range: rangeStr,
                },
            };

            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState, ecosystemFunctions),
                isEqualsSaved: true,
            };

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 23+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsMyActionsFilters/reducer.js